{
  "welcome": {
    "title": "Bienvenue dans le centre d'appel",
    "description": "Cliquez sur continuer pour activer les notifications sonores pour recevoir des alertes lorsqu'un appel est reçu.",
    "continue": "Continuer"
  }
}